const SCREENSHOT_SERVER = 'https://terminal.clubhouse.no:4433/';

// Cached per page load — null = not checked yet, true/false = result
let localServerAvailable = null;

function getFormattedTimestamp() {
  const now = new Date();
  const time = `${String(now.getHours()).padStart(2, '0')}-${String(
    now.getMinutes()
  ).padStart(2, '0')}-${String(now.getSeconds()).padStart(2, '0')}`;
  const date = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
    2,
    '0'
  )}-${String(now.getDate()).padStart(2, '0')}`;
  return [`${date} `, `${time} `];
}

export async function checkLocalServer() {
  if (localServerAvailable !== null) return localServerAvailable;
  try {
    await fetch(SCREENSHOT_SERVER, {
      method: 'HEAD',
      mode: 'no-cors',
      cache: 'no-store',
    });
    localServerAvailable = true;
  } catch {
    localServerAvailable = false;
  }
  return localServerAvailable;
}

export async function takeFullScreenshot() {
  const [date, time] = getFormattedTimestamp().map((s) => s.trim());
  const fileName = `Date-${date}_Time-${time}`;

  const url =
    `${SCREENSHOT_SERVER}Screenshots/Take` +
    `?gameType=Cashier&fileName=${fileName}`;

  try {
    const res = await fetch(url);

    if (!res.ok) {
      console.error('Screenshot request failed:', res.status);
    }
  } catch (err) {
    console.error('Network error while taking screenshot:', err);
  }
}
